import { useEffect, useState } from 'react'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import {
  isSuperAdmin as superAdmin,
  useCanUserAccess,
} from '../../../../app/pages/store/userRoleGrants'
import { getAuth, JwtPayload } from '../../../../app/modules/auth'
import jwtDecode from 'jwt-decode'
import useIsMobile from '../../../../utils/detectDevice'
import { getUserInvestors } from '../../../../utils/SessionStorageUtils'
import { InvestorType } from '../../../../app/pages/accounts/components/AddInvestor'

export function AsideMenuMain() {
  const [header, setHeader] = useState('')
  const auth = getAuth()!
  const jwt = jwtDecode<JwtPayload>(auth)
  useEffect(() => {
    setHeader(window.location.pathname)
  }, [])

  const isAccountAdmin = sessionStorage.getItem('isAccountAdmin') === 'true' ? true : false
  const dataSetsString = sessionStorage.getItem('datasets')
  const dataSets = dataSetsString ? JSON.parse(dataSetsString) : null

  const isSuperAdmin = superAdmin()
  const routes = ['/adduser', '/addInvestor', '/addAccount', '/noAccess']
  const canDashboard = useCanUserAccess('read', 'dashboard')
  const canPortfolio = useCanUserAccess('read', 'portfolio')
  const canWatchlist = useCanUserAccess('read', 'watchlist')
  const canDeals = useCanUserAccess('read', 'documentAssembler')
  const canPrivateCaptables = useCanUserAccess('read', 'myCaptables')
  const canDynamicTables = useCanUserAccess('read', 'dynamicTable')
  const canExitEnabler = useCanUserAccess('read', 'exitEnabler')
  const canExitEnablerAdmin = useCanUserAccess('read', 'exitEnablerAdmin')
  const canProject = useCanUserAccess('read', 'project')
  const canDealFlow = useCanUserAccess('read', 'dealFlow')
  const { isMobile } = useIsMobile(1024)
  const isAdmin = useCanUserAccess('*', '*')

  // const investorTypes = getUserInvestors('userInvestors')
  // const isAngelOnly = investorTypes.every(
  //   (investorType) => investorType.type.toString() === InvestorType.Angel.toString()
  // )
  const investorTypes = getUserInvestors('userInvestors') || []
  const isAngelOnly =
    investorTypes.length > 0 &&
    investorTypes.every(
      (investorType) =>
        investorType?.type != null && investorType.type.toString() === InvestorType.Angel.toString()
    )

  return (
    <>
      {routes.includes(header) ? (
        <></>
      ) : (
        <>
          {isMobile && (
            <AsideMenuItem
              title=''
              icon='media/logos/favicon.png'
              fontIcon='bi-app-indicator'
              to=''
              isHeader={true}
              disabled={true}
            />
          )}
          {isMobile && <span className='pb-4'></span>}
          {canDashboard && (
            <AsideMenuItem
              to='/dashboard'
              title='Dashboard'
              icon='/media/icons/duotune/layouts/lay001.svg'
              fontIcon='bi-app-indicator'
            />
          )}
          {canPortfolio && (
            <AsideMenuItem
              to='/portfolio'
              title='Portfolios'
              icon='/media/icons/duotune/graphs/gra010.svg'
              fontIcon='bi-app-indicator'
            />
          )}
          {canWatchlist && (
            <AsideMenuItem
              to='/watchlist'
              title='Watchlist'
              icon='/media/icons/duotune/general/gen004.svg'
              fontIcon='bi-app-indicator'
            />
          )}
          {/* {(isAdmin || canDeals) && (
            <AsideMenuItem
              to='/contracts'
              title='Contracts'
              icon='/media/icons/duotune/finance/fin010.svg'
              fontIcon='bi-app-indicator'
            />
          )} */}
          {isAngelOnly && isAdmin && (
            <AsideMenuItem
              to='/esopModule'
              title='ESOPs'
              icon='/media/icons/duotune/general/gen032.svg'
              fontIcon='bi-app-indicator'
            />
          )}
          {/* {canFundMetrics && (
            <AsideMenuItem
              to='/fundmetrics'
              title='Metrics'
              icon='/media/icons/duotune/abstract/abs027.svg'
              fontIcon='bi-app-indicator'
            />
          )} */}
          {(canExitEnabler || canExitEnablerAdmin) && (
            <AsideMenuItem
              to='/exitEnabler'
              title='Exit Enabler'
              icon='/media/icons/duotune/finance/fin006.svg'
              fontIcon='bi-app-indicator'
            />
          )}
          {/* {canPrivateCaptables && (
            <AsideMenuItem
              to='/myCaptables'
              title='My Captables'
              icon='/media/icons/duotune/layouts/lay009.svg'
              fontIcon='bi-app-indicator'
            />
          )} */}
          {dataSets && dataSets.length > 0 && !isSuperAdmin && !canDynamicTables && isAdmin && (
            <AsideMenuItemWithSub
              to=''
              title='Datasets'
              icon='/media/icons/duotune/layouts/lay006.svg'
              fontIcon='bi-app-indicator'
            >
              {dataSets?.map((dataSet: any) => (
                <AsideMenuItem
                  key={dataSet.id}
                  to={`/privateData/${dataSet.id}`}
                  title={dataSet.name}
                  icon='/media/icons/duotune/abstract/abs015.svg'
                  fontIcon='bi-app-indicator'
                  state={{ ...dataSet }}
                />
              ))}
            </AsideMenuItemWithSub>
          )}
          {(isSuperAdmin || canDynamicTables) && isAdmin && (
            <AsideMenuItemWithSub
              to='/privateData'
              title='Datasets'
              icon='/media/icons/duotune/layouts/lay006.svg'
              fontIcon='bi-app-indicator'
            >
              {dataSets?.map((dataSet: any) => (
                <AsideMenuItem
                  key={dataSet.id}
                  to={`/privateData/${dataSet.id}`}
                  title={dataSet.name}
                  icon='/media/icons/duotune/abstract/abs015.svg'
                  fontIcon='bi-app-indicator'
                  state={{ ...dataSet }}
                />
              ))}
            </AsideMenuItemWithSub>
          )}

          {/* {canDynamicTables && (
            <AsideMenuItem
              to='/privateData'
              title='Datasets'
              icon='/media/icons/duotune/layouts/lay006.svg'
              fontIcon='bi-app-indicator'
            />
          )} */}
          {canProject && (
            <AsideMenuItem
              to='/taskManager'
              title='Projects'
              icon='/media/icons/duotune/general/gen010.svg'
              fontIcon='bi-app-indicator'
            />
          )}
          {canDealFlow && (
            <AsideMenuItem
              to='/dealFlow'
              title='Deal Flow'
              icon='/media/icons/duotune/finance/fin008.svg'
              fontIcon='bi-app-indicator'
            />
          )}
          {isAccountAdmin && (
            <AsideMenuItem
              to='/reports'
              title='Reports'
              icon='/media/icons/duotune/files/fil008.svg'
              fontIcon='bi-file-earmark-text'
            />
          )}
        </>
      )}
    </>
  )
}
